import { type VoucherForCampaignInput } from "@/lib/gql/__generated__/graphql";

import type { MarketingCampaignFormModel } from "../../../../../type";

type Props = {
	viewModel: MarketingCampaignFormModel["ViewModel"];
};

export const viewModelToInputConverter = ({ viewModel }: Props): VoucherForCampaignInput => {
	const input: VoucherForCampaignInput = {
		hotelID: viewModel.hotelID,
		voucherID: viewModel.voucherID,

		inSale: viewModel.inSale.value,

		name: viewModel.name.value,
		description: viewModel.description.value,

		mainKeyVisual: {
			bucket: viewModel.mainKeyVisual.bucket.value,
			key: viewModel.mainKeyVisual.key.value,
			region: viewModel.mainKeyVisual.region.value,
			mimeType: viewModel.mainKeyVisual.mimeType?.value,
			fileName: viewModel.mainKeyVisual.fileName?.value,
		},

		voucherPrice: {
			currencyType: viewModel.voucherPrice.currencyType.value,
			// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
			amount: viewModel.voucherPrice.amount?.value,
		},
		resourceAvailablePrice: {
			currencyType: viewModel.resourceAvailablePrice.currencyType.value,
			// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
			amount: viewModel.resourceAvailablePrice.amount?.value,
		},

		mailTemplate: viewModel.mailTemplate.value,
		voucherExplanationForHost: viewModel.voucherExplanationForHost.value,
		voucherGiftList: viewModel.voucherGiftList.value.map((item) => {
			return {
				guestEmail: item.guestEmail?.value,
				guestName: item.guestName?.value,
				guestTel: item.guestTel?.value ?? "",
			};
		}),

		cinStart: viewModel.cinStart.value,
		cinEnd: viewModel.cinEnd.value,
	} satisfies VoucherForCampaignInput;

	return input;
};
